/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ContainerPublicAccess } from 'src/core/services/azure/azureSwaggers';

/**
 * Azure Azure Blob Container data type.
 */
export type AzureBlobContainerData = Partial<Omit<AzureBlobContainerStore, 'id'>>;

/**
 * Represents a Azure Blob Container.
 */
export class AzureBlobContainerStore {
    public readonly id: string;

    public readonly name: string;

    public readonly publicAccess: ContainerPublicAccess;

    constructor(id: string, azureBlobContainerData: AzureBlobContainerData) {
        this.id = id;
        this.name = azureBlobContainerData.name;
        this.publicAccess = azureBlobContainerData.publicAccess;
    }
}

export const createAzureBlobContainerStore = (id: string, azureBlobContainerData: AzureBlobContainerData) =>
    new AzureBlobContainerStore(id, azureBlobContainerData);
